import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icons/Icon';
import Box from '../Styled/Box';
import Typography from '../Typography/Typography';

const Checkbox = ({
  disabled,
  value,
  checked,
  onChange,
  label,
  boxProps,
  typographyProps,
  iconProps,
  radio,
  icons: iconsProps,
}) => {
  const icons = iconsProps || (radio ? ['dot-circle', 'circle'] : ['check-square', 'square']);

  return (
    <Box
      onClick={() => (!disabled ? onChange(value) : null)}
      style={{
        ...boxProps.style,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      {...boxProps}
    >
      <Icon
        icon={checked ? icons[0] : icons[1]}
        color={checked ? 'teal' : 'coldgrey400'}
        checked={checked}
        disabled={disabled}
        {...iconProps}
        style={{
          ...(iconProps.style || {}),
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      />

      <Typography
        variant='body'
        tag='span'
        ml='12px'
        {...typographyProps}
      >
        {label}
      </Typography>
    </Box>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  radio: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  boxProps: PropTypes.object,
  typographyProps: PropTypes.object,
  iconProps: PropTypes.object,
  value: PropTypes.any.isRequired,
  icons: PropTypes.array,
};

Checkbox.defaultProps = {
  checked: false,
  radio: false,
  onChange: () => { },
  label: '',
  disabled: false,
  boxProps: {},
  typographyProps: {},
  iconProps: {},
  icons: null,
};

export default Checkbox;
